import React from "react"
import { Check } from "lucide-react"
import ModalForm from "components/common/modal/ModalForm"
import { WalletTransaction } from "@/types/TransactionsType"

type CreditDemandValidationModalProps = {
  open: boolean
  onClose: () => void
  onValidate: () => void
  transaction: WalletTransaction
}

const CreditDemandValidationModal = ({ open, onClose, onValidate, transaction }: CreditDemandValidationModalProps) => {
  return (
    <ModalForm
      open={open}
      onClose={onClose}
      title="Validation de la demande de rechargement"
      submitButtonLabel={
        <span className="flex items-center gap-2">
          <Check size={16} />
          Valider
        </span>
      }
      cancelButtonLabel="Annuler"
      modalWidth="2xl"
      formSubmit={onValidate}
    >
      <div className="space-y-6 my-5">
        Voulez-vous vraiment valider la demande <b>{transaction.reference}</b> ?
      </div>
    </ModalForm>
  )
}

export default CreditDemandValidationModal